var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { staticClass: "w-auto", attrs: { label: "Inspection Types" } },
        [
          _c(
            "el-checkbox",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.inspType1,
                callback: function ($$v) {
                  _vm.inspType1 = $$v
                },
                expression: "inspType1",
              },
            },
            [_vm._v("Exterior")]
          ),
          _c(
            "el-checkbox",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.inspType2,
                callback: function ($$v) {
                  _vm.inspType2 = $$v
                },
                expression: "inspType2",
              },
            },
            [_vm._v("Int/Ext With Floorplan")]
          ),
          _c(
            "el-checkbox",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.inspType3,
                callback: function ($$v) {
                  _vm.inspType3 = $$v
                },
                expression: "inspType3",
              },
            },
            [_vm._v("Int/Exp No Floorplan")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }